/**
 * Expandable team members for studio page
 */
export function initStudioTeam() {
  const teamMembers = document.querySelectorAll('.js-team-member');
  
  if (teamMembers.length === 0) return;
  
  teamMembers.forEach((member) => {
    const header = member.querySelector('.c-inside-team__member__header');
    const expandable = member.querySelector('.c-inside-team__member__expandable');
    
    if (!header || !expandable) return;
    
    // Initialize state
    member.setAttribute('data-state', 'closed');
    
    // Handle click
    header.addEventListener('click', (e) => {
      e.preventDefault();
      
      const isClosed = member.getAttribute('data-state') === 'closed';
      
      // Close all other members
      teamMembers.forEach((otherMember) => {
        if (otherMember !== member) {
          otherMember.setAttribute('data-state', 'closed');
        }
      });
      
      // Toggle current member
      member.setAttribute('data-state', isClosed ? 'open' : 'closed');
    });
  });
}

